// Add your custom JS here.

import '../../blocks/accordion/accordion.js';
import '../../blocks/calculator-with-text/calculator-with-text.js';
//import '../../blocks/hero-header/hero-header.js';
import '../../blocks/media-only/media-only.js';
import '../../blocks/our-team/our-team.js';
import '../../blocks/related-insights/related-insights.js';
import '../../blocks/scrolling-timeline/scrolling-timeline.js';
import '../../blocks/slider-large/slider-large.js';
import '../../blocks/sliding-cards/sliding-cards.js';
import '../../blocks/stat-columns/stat-columns.js';
import '../../blocks/stat-columns-minimal/stat-columns-minimal.js';
import '../../blocks/stat-counter-tabbed-view/stat-counter-tabbed-view.js';
import '../../blocks/tabbed-content/tabbed-content.js';
import '../../blocks/testimonials/testimonials.js';
import '../../blocks/text-with-media/text-with-media.js';
import '../../blocks/trustmarks/trustmarks.js';

const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
const adaptiveHeader = document.querySelector('.adaptive-header');
const siteHeaderBar = document.querySelector('#site-header');

// Inject a toggle button beside each parent menu item's link
document.querySelectorAll('.main-menu > .menu-item-has-children').forEach(li => {
    const btn = document.createElement('button');
    btn.className = 'submenu-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Toggle submenu');
    li.querySelector(':scope > a').before(btn);

    const subMenu = li.querySelector(':scope > .sub-menu');

    btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (!isOpen) {
            const subHeight = subMenu.scrollHeight;
            subMenu.style.height = subHeight + 'px';
            adaptiveHeader.style.height = (parseFloat(adaptiveHeader.style.height) + subHeight) + 'px';
            btn.setAttribute('aria-expanded', 'true');
        } else {
            const subHeight = parseFloat(subMenu.style.height);
            subMenu.style.height = '0';
            adaptiveHeader.style.height = (parseFloat(adaptiveHeader.style.height) - subHeight) + 'px';
            btn.setAttribute('aria-expanded', 'false');
        }
    });
});

mobileNavToggle.addEventListener('click', function() {
    const isOpen = mobileNavToggle.classList.contains('clicked');

    if (!isOpen) {
        // Header colour changes immediately, then menu slides down
        mobileNavToggle.classList.add('clicked');
        siteHeaderBar.classList.add('mobile-menu-active');
        adaptiveHeader.style.height = adaptiveHeader.scrollHeight + 'px';
    } else {
        // Menu slides up first, header colour reverts only once it finishes
        document.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach(btn => {
            btn.closest('li').querySelector('.sub-menu').style.height = '0';
            btn.setAttribute('aria-expanded', 'false');
        });
        mobileNavToggle.classList.remove('clicked');
        adaptiveHeader.style.height = '0';
        adaptiveHeader.addEventListener('transitionend', function() {
            siteHeaderBar.classList.remove('mobile-menu-active');
        }, { once: true });
    }
});

// Reset inline heights and state when resizing back to desktop
window.addEventListener('resize', () => {
    if (window.innerWidth >= 992) { // Bootstrap default lg breakpoint — matches $grid-breakpoints lg in SCSS
        adaptiveHeader.style.height = '';
        document.querySelectorAll('.sub-menu').forEach(s => s.style.height = '');
        document.querySelectorAll('.submenu-toggle').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        mobileNavToggle.classList.remove('clicked');
        siteHeaderBar.classList.remove('mobile-menu-active');
    }
});

// Reliable anchor scroll handler.
// Overrides CSS scroll-behavior so the target position is calculated fresh at
// click time rather than committed once at navigation start — prevents scroll
// stopping partway when block JS (sliders, etc.) shifts the layout mid-animation.
function anchorSmoothScroll(target) {
    const top = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top, behavior: 'smooth' });
}

document.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    anchorSmoothScroll(target);
    history.pushState(null, '', '#' + id);
});

// Cross-page anchor links: re-scroll after all resources and block scripts have
// finished loading so slider/block heights are stable before calculating position.
if (window.location.hash) {
    window.addEventListener('load', () => {
        const id = window.location.hash.slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        setTimeout(() => anchorSmoothScroll(target), 100);
    });
}